import React from 'react'
import {
  Box,
  Color,
  Display,
  Icon,
  IconVariant,
  FontWeight,
  Space,
  Text,
} from '@gousto-internal/citrus-react'

const CustomerNotification = () => (
  <Box
    display={Display.Flex}
    bg={Color.Informative_50}
    maxWidth={['100%', '50rem']}
    paddingH={[3, 4]}
    paddingV={4}
  >
    <Box paddingRight={4}>
      <Icon name="info" variant={IconVariant.Actionable} />
    </Box>
    <Box>
      <Text size={2} fontWeight={FontWeight.SemiBold}>
        Please expect longer waiting times to contact us!
      </Text>
      <Space size={3} />
      <Text>
        Unfortunately, we are experiencing a higher number of contacts at the moment.
        We suggest reaching out in a couple of hours to avoid longer wait times.
      </Text>
    </Box>
  </Box>
)

export { CustomerNotification }
